import { render, staticRenderFns } from "./homeDept.vue?vue&type=template&id=4188dc90&scoped=true&"
import script from "./homeDept.vue?vue&type=script&lang=js&"
export * from "./homeDept.vue?vue&type=script&lang=js&"
import style0 from "./homeDept.vue?vue&type=style&index=0&id=4188dc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188dc90",
  null
  
)

export default component.exports